<template>
  <div class="template_pop" v-if="agreementShow">
    <div>
      <div class="template_pop_title">运营猫商机领航用户协议</div>
      <div v-html="content" class="rule_content"></div>
      <el-button type="primary" size="small" @click="close">确认协议</el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { baseApi } from '@/api/baseApi'
export default {
  props: {
    agreementShow: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      content:''
    }
  },
  mounted() {
    this.getAboutUs()
  },
  methods: {
    getAboutUs() {
      let params = {
        type: 2,
        openid: this.accountInfo.openid,
      }
      baseApi
        .getAboutUs(params)
        .then((res) => {
          this.content = res.data.content
        })
        .catch((err) => {
          this.$message.error(err.error)
        })
    },
    close() {
      this.$parent.agreementShow = false
    },
  },
  computed: {
    ...mapState(['accountInfo']),
  },
}
</script>
<style lang="scss" scoped>
.template_pop {
  .rule_ItemTitle {
    font-size: 14px;
    color: var(--color_mainText);
    font-weight: 600;
    margin: 20px 0 10px;
  }
  .rule_content {
    overflow: auto;
  }
}
</style>
